const UBIGEO_JSON_URL = 'resources/ubigeo.json';
const reclamacionesPage = document.querySelector('#reclamaciones');

const departamentos = document.querySelector('#departamento');
const provincias = document.querySelector('#provincia');
const distritos = document.querySelector('#distrito');

let ubigeoData = "";

if(reclamacionesPage){
    document.addEventListener("DOMContentLoaded", cargarUbigeoData);
}

async function cargarUbigeoData(){
    try {
        const response = await fetch(UBIGEO_JSON_URL);

        if(!response.ok){
            throw new Error(`Error HHTP: ${response.status } ${(response).statusText}`);
        }

        ubigeoData = await response.json();
        // console.log("Datos cargados ");
        
        inicializarUbigeoSelects();

    } catch (error) {
        console.log(`Error ${error}`);
    }
}

function addDefaultOptions(){
    const defaultOption = document.createElement('OPTION');

    defaultOption.textContent = 'Seleccionar provincia';
    departamentos.appendChild(defaultOption);

    defaultOption.textContent = 'Seleccionar distrito';
    distritos.appendChild(defaultOption);

};

function inicializarUbigeoSelects(){

    const defaultOption = document.createElement('OPTION');
    defaultOption.textContent = 'Seleccionar departamento';
    departamentos.appendChild(defaultOption);

    addDefaultOptions();

    ubigeoData.forEach(dep => {
        const option = document.createElement('OPTION');
        option.value = dep.id;
        option.textContent = dep.name;

        departamentos.appendChild(option);
    });

    departamentos.addEventListener('change', ()=>{
        provincias.options.length = 0;
        distritos.options.length = 0;
        addDefaultOptions()

        const departamentoId = departamentos.value;
        const defaultOption = document.createElement('OPTION');
        defaultOption.textContent = 'Seleccionar provincia';
        provincias.appendChild(defaultOption);
        
        if(departamentos.options[departamentos.selectedIndex].hasAttribute('value')){
            const selectedDep = ubigeoData.find(dep => dep.id === departamentoId)
            selectedDep.provinces.forEach(prov =>{
                const option = document.createElement('OPTION');
                option.value = prov.id;
                option.textContent = prov.name;
        
                provincias.appendChild(option);
            })
        }
    })

    provincias.addEventListener('change', ()=>{
        distritos.options.length = 0;

        const departamentoId = departamentos.value;
        const provinciaId = provincias.value;

        const defaultOption = document.createElement('OPTION');
        defaultOption.innerText = 'Seleccionar distrito';
        distritos.append(defaultOption);

        if(departamentos.options[departamentos.selectedIndex].hasAttribute('value')){
            const selectedDep = ubigeoData.find(dep => dep.id === departamentoId);
            
            if(provincias.options[provincias.selectedIndex].hasAttribute('value')){
                const selectedProv = selectedDep.provinces.find(prov => prov.id === provinciaId)
                
                selectedProv.districts.forEach(prov =>{
                    const option = document.createElement('OPTION');
                    option.textContent = prov.name;

                    distritos.appendChild(option);
                })
            }
            
        }
    })
}